import styled from "@emotion/styled";
import { Variables } from "@repo/skapa";

export const CheckboxContainer = styled.div`
  margin-bottom: ${Variables.space125};

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const CheckboxTitleContainer = styled.div`
  margin-bottom: ${Variables.space100};
`;
